// export const decentrogeAddress = "0x9033A8F26B0Bc5DeF4381908fdf28DA99f36cCa1";
// export const decentrogeAddress = "0x5d56570a8e9b725eCE0518172D7207bc9a1D3d04";
export const decentrogeAddress = "0xE319BCfA9E5B8d7db7c830579B560367D42AF31b";
